import script from "./DashboardSuppliersStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardSuppliersStatistics.vue?vue&type=script&setup=true&lang=js"

import "./DashboardSuppliersStatistics.vue?vue&type=style&index=0&id=7871aa48&lang=css"

const __exports__ = script;

export default __exports__